import React from "react";
import Select from "react-select";

const daysOfWeek = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
];

export default function DaysSelector({ selectedDayNums, onDaysChange }) {
  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    onDaysChange(selectedValues);
  };

  const defaultValues = daysOfWeek.filter((day) => selectedDayNums.includes(day.value));

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "2.75rem",
      border: "none",
    }),
  };

  return (
    <Select
      styles={customStyles}
      className="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
      options={daysOfWeek}
      isMulti
      value={defaultValues}
      onChange={handleChange}
      placeholder="Select days"
    />
  );
}
